import { create } from 'zustand';
import { createSelectors, StoreName, withDevtools } from '../config';
import { createUploadProgressSlice } from './slice';
import type { UploadProgressSlice } from './types';

export const useUploadProgressStore = createSelectors(
  create<UploadProgressSlice>()(
    withDevtools(
      (set, get, store) => ({
        ...createUploadProgressSlice(set, get, store),
      }),
      StoreName.UploadProgress
    )
  )
);

export * from './types';
